(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider-lizzom"] && !Shopify.designMode) return;
  try {
    
// Add this before your Swiper initialization
document.addEventListener('DOMContentLoaded', function() {
  // Remove empty slides
  const slides = document.querySelectorAll('.solution-slider .swiper-slide');
  slides.forEach(function(slide) {
    const hasImage = slide.querySelector('img');
    const hasTitle = slide.querySelector('.solution-title');
    const titleText = hasTitle ? hasTitle.textContent.trim() : '';
    
    // Remove slide if it has no image and no title text
    if (!hasImage && (!hasTitle || titleText === '')) {
      slide.remove();
    }
  });

  // Then initialize Swiper
  var swiper = new Swiper('.solution-slider.solution-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    //slidesOffsetBefore: 20,
    //slidesOffsetAfter: 20,
    centeredSlides: false,
    navigation: {
      nextEl: '.image-swiper-button-next',
      prevEl: '.image-swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
       // slidesOffsetBefore: 70,
        //slidesOffsetAfter: 70
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 20,
        //slidesOffsetBefore: 70,
        //slidesOffsetAfter: 70
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
